import * as React from 'react';
import styles from './drop-area.scss';

export interface DropAreaProps {
  text: string;
}

export const DropArea: React.FC<DropAreaProps> = ({ text }) => {
  return (<div className={styles.dragndropArea}>
    <div className={styles.dragToBox}>
      {text}
    </div>
  </div>);
};
